import { pushDataLayer } from '../../../../../utils/datalayer'
import { DataLayerEcommerceProduct } from '../createDataLayerEcommerceProduct'

// MiniCart
export const pushDataLayerDisplayMiniCart = () => {
  pushDataLayer([
    {
      key: 'event',
      value: 'miniCartDisplay'
    }
  ])
}

export const pushDataLayerAddToCartEvent = (product) => {
  pushDataLayer([
    {
      key: 'event',
      value: 'addToCart'
    },
    {
      key: 'ecommerce',
      value: {
        add: {
          products: [
            {
              product
            }
          ]
        }
      }
    }
  ])
}

export const pushDataLayerMiniCartSeeCartClick = () => {
  pushDataLayer([
    {
      key: 'event',
      value: 'miniCartSeeCartClick'
    }
  ])
}

export const pushDataLayerMiniCartValidateOrderClick = () => {
  pushDataLayer([
    {
      key: 'event',
      value: 'miniCartValidateOrderClick'
    }
  ])
}

// ConfigureAndBuy
export const pushDataLayerProductDetailsView = (product) => {
  pushDataLayer([
    {
      key: 'event',
      value: 'productDetailsView'
    },
    {
      key: 'ecommerce',
      value: {
        detail: {
          products: [product]
        }
      }
    }
  ])
}

// ProductList
export const pushDataLayerSelectedFilter = (
  category: string,
  id: string,
  option: string
) => {
  pushDataLayer([
    { key: 'event', value: 'productListFilterSelect' },
    {
      key: 'productListFilterCategory',
      value: category
    },
    {
      key: 'productListFilterID',
      value: id
    },
    {
      key: 'productListFilterSelectOption',
      value: option
    }
  ])
}

export const pushDataLayerProductListView = (
  products: DataLayerEcommerceProduct[]
) => {
  pushDataLayer([
    {
      key: 'event',
      value: 'productImpression'
    },
    {
      key: 'ecommerce',
      value: {
        impressions: products
      }
    }
  ])
}

export const pushDataLayerProductListVariantChange = (
  product: DataLayerEcommerceProduct
) => {
  pushDataLayer([
    {
      key: 'event',
      value: 'productImpressionVariantChange'
    },
    {
      key: 'ecommerce',
      value: {
        impressions: [product]
      }
    }
  ])
}

export const pushDataLayerProductListVariantClick = (
  product: DataLayerEcommerceProduct,
  url: string
) => {
  pushDataLayer([
    {
      key: 'event',
      value: 'productClick'
    },
    {
      key: 'ecommerce',
      value: {
        click: {
          actionField: { list: product?.list },
          products: [product]
        }
      }
    },
    {
      key: 'eventCallback',
      value() {
        document.location = url
      }
    }
  ])
}
